import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Alert, Spin } from "antd";
import { useEffect } from "react";
import { cmsApi } from "@innovate/cms-admin-ui";
import { LegacyAdminApp } from "./legacy/LegacyAdminApp";
import { LoginPage } from "./pages/LoginPage";

export function App() {
  const queryClient = useQueryClient();
  const me = useQuery({ queryKey: ["me"], queryFn: cmsApi.me, retry: false });

  useEffect(() => {
    const unauthorized = () => queryClient.setQueryData(["me"], null);
    window.addEventListener("cms:unauthorized", unauthorized);
    return () => window.removeEventListener("cms:unauthorized", unauthorized);
  }, [queryClient]);

  if (me.isLoading) return <div className="grid min-h-screen place-items-center"><Spin size="large" /></div>;
  if (!me.data) return <LoginPage />;
  if (me.error) return <Alert type="error" showIcon message={me.error.message} />;
  return <LegacyAdminApp user={me.data} />;
}
